import { getLocaleFromPathname } from "@/lib/utils/tracking/siteContext"
import { usePathname } from "next/navigation"
import { useMemo } from "react"

/**
 * Custom hook to extract locale from pathname with memoization
 * Reusable across components to avoid redundant getLocaleFromPathname calls
 *
 * @returns {string} The extracted locale from the current pathname
 */
export const useLocaleFromPathname = (): string => {
    const pathname = usePathname()

    return useMemo(() => getLocaleFromPathname(pathname), [pathname])
}

/**
 * Custom hook to extract locale from a specific pathname (for non-Next.js contexts)
 * Useful for components that need locale from window.location.pathname or other sources
 *
 * @param pathname - The pathname to extract locale from
 * @returns {string} The extracted locale from the provided pathname
 */
export const useLocaleFromSpecificPathname = (pathname: string): string => {
    return useMemo(() => getLocaleFromPathname(pathname), [pathname])
}
